import { render } from "./HomePage.component.vue?vue&type=template&id=697af5fe"
import script from "./HomePage.component.vue?vue&type=script&lang=js"
export * from "./HomePage.component.vue?vue&type=script&lang=js"

import "./HomePage.component.vue?vue&type=style&index=0&id=697af5fe&lang=scss"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/homePage/HomePage.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "697af5fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('697af5fe', __exports__)) {
    console.log('reload')
    api.reload('697af5fe', __exports__)
  }
  
  module.hot.accept("./HomePage.component.vue?vue&type=template&id=697af5fe", () => {
    console.log('re-render')
    api.rerender('697af5fe', render)
  })

}


export default __exports__